import { LogsService } from '@gtpl/shared-services/user-logs';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { UomsAdapter } from './dto/uom.adapter';
import { Uoms } from './uom.entity';
import { UomsController } from './uoms.controller';
import { UomsService } from './uoms.service';

@Module({
  imports: [
    
    TypeOrmModule.forFeature([Uoms]),
    // forwardRef(() => ClusterModule),
  ],
  controllers: [UomsController],
  providers: [UomsService,UomsAdapter,ApplicationExceptionHandler,LogsService],
  exports:[UomsService]
})
export class UomsModule {}
